export const wtLinkParams = {
  pageName: 'portal:appointment_details',
  container: 'appointment_details',
  action: 'click',
  objectType: 'link',
};
